export default function UserSkeleton() {
  return <div className='flex w-6 animate-pulse lg:w-[60px]' data-sentry-component="UserSkeleton" data-sentry-source-file="user-skeleton.tsx">
            <div className='w-full'>
                <ul className='space-y-2'>
                    <li className='h-2 w-full rounded-md bg-gray-200'></li>
                    <li className='h-2 w-full rounded-md bg-gray-200'></li>
                </ul>
            </div>
        </div>;
}